// ─────────────────────────────────────────────────────────────────────────────
// SAP Insights POC — Platform Constants
// Mirrors config/automationPlatforms.ts's shape. Query keys must match
// SAP_PLATFORM_HIERARCHY in the backend's automation/config/sap_platforms.py
// exactly — these are dev-only POC platforms, no automation exists for them.
// ─────────────────────────────────────────────────────────────────────────────

export interface SapPlatformOption {
  label: string;
  value: string;
}

export const SAP_PLATFORM_OPTIONS: SapPlatformOption[] = [
  { label: 'SAP DevOps Basis', value: 'SAP_DEVOPS_BASIS' },
  { label: 'SAP S4 HANA,FACT & Ocean Release management', value: 'SAP_RELEASE_MGMT' },
  { label: 'SAP Tech ALM', value: 'SAP_TECH_ALM' },
  { label: 'SAP Tech Infrastructure team', value: 'SAP_TECH_INFRA' },
  { label: 'SAP Tech Security', value: 'SAP_TECH_SECURITY' },
];

/** Reverse lookup: query_key -> display label, same role as PLATFORM_LABEL_BY_KEY. */
export const SAP_PLATFORM_LABEL_BY_KEY: Record<string, string> = Object.fromEntries(
  SAP_PLATFORM_OPTIONS.map(({ label, value }) => [value, label])
);
